import axios from 'axios';
import { getAuth } from '../providers/AppAuthProvider';
import { Resources } from '../resources/resource';

import { API_BASE_URL as baseUrl } from 'src/utils/api-url';
const resource = Resources.adminConfig;

export async function findAdminConfig(code: string) {
  const url = `${baseUrl}/${resource}/${code}`;

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: 'application/json',
  };

  return axios.get<any>(url, {
    headers,
  });
}
